import Offcanvas from 'bootstrap/js/src/offcanvas'

import { variables } from '../common/variables'

const OFFCANVAS_ID = '#offcanvasSearch'
const TOGGLE_SELECTOR = `[data-bs-target="${OFFCANVAS_ID}"]`

const getOffcanvasSearchElements = () => {
  const el = document.querySelector(OFFCANVAS_ID)
  return {
    el,
    instance: el ? Offcanvas.getOrCreateInstance(el) : null,
    toggleButtons: document.querySelectorAll(TOGGLE_SELECTOR)
  }
}

export const OffcanvasSearchClickAway = () => {
  const { el, instance, toggleButtons } = getOffcanvasSearchElements()
  if (!el || !instance) return

  document.addEventListener('click', (event) => {
    const isClickInside = el.contains(event.target)
    const isToggleButton = event.target.closest('[data-bs-toggle="offcanvas"]')

    if (instance._isShown && !isClickInside && !isToggleButton) {
      instance.hide()
      toggleButtons.forEach((btn) => btn.removeAttribute('data-open'))
    }
  })
}

export const headerSearchToggle = () => {
  const button = document.querySelector('[data-js="search"]')
  const searchResults = document.querySelector('[data-js="search-results"]')
  const searchResultsWrapper = document.querySelector('[data-js="search-results-wrapper"]')
  const searchForm = document.querySelector('[data-js="search-form"]')
  if (button && searchResults && searchResultsWrapper && searchForm) {
    document.addEventListener('search-open', () => {
      if (document.documentElement.classList.contains('menu-open')) {
        document.dispatchEvent(new Event('menu-close'))
      }

      document.documentElement.classList.add('search-open')
      searchResults.classList.add('is-open')
      searchForm.classList.add('is-open')
      searchForm.reset()

      button.dataset.open = true
    })

    document.addEventListener('search-close', () => {
      document.documentElement.classList.remove('search-open')
      searchResults.classList.remove('is-open')
      searchForm.classList.remove('is-open')
      searchForm.reset()
      searchResultsWrapper.innerHTML = ''

      button.removeAttribute('data-open')
    })

    // Toggle the search using the button
    button.addEventListener('click', (e) => {
      e.preventDefault()

      if (!button.dataset.open) {
        document.dispatchEvent(new Event('search-open'))
      } else {
        document.dispatchEvent(new Event('search-close'))
      }
    })

    // Close the search using the background
    searchResults.addEventListener('click', (e) => {
      if (e.target === e.currentTarget && searchResults.classList.contains('is-open')) {
        if (button.dataset.open) {
          document.dispatchEvent(new Event('search-close'))
        }
      }
    })

    // Close the search using escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (button.dataset.open) {
          document.dispatchEvent(new Event('search-close'))
        }
      }
    })
  }
}

export const errorSearchToggle = () => {
  const searchResultsWrapper = document.querySelector('[data-js="search-results-wrapper"]')
  const searchForm = document.querySelector('[data-js="search-form"]')

  if (searchResultsWrapper && searchForm) {
    document.addEventListener('error-search-open', () => {
      if (!searchResultsWrapper.classList.contains('is-open')) {
        searchResultsWrapper.classList.add('is-open')
      }
    })

    document.addEventListener('error-search-close', () => {
      if (searchResultsWrapper.classList.contains('is-open')) {
        searchResultsWrapper.classList.remove('is-open')
      }
    })

    // Open the search results on focus
    searchForm.addEventListener('click', () => {
      document.dispatchEvent(new Event('error-search-open'))
    })

    // Close the search results on click outside
    document.addEventListener('click', (e) => {
      const isSearchParts = e.target.closest('[data-js="search-results-wrapper"]') || e.target.closest('[data-js="search-form"]')
      if (!isSearchParts) {
        document.dispatchEvent(new Event('error-search-close'))
      }
    })

    // Close the search using escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.dispatchEvent(new Event('error-search-close'))
      }
    })
  }
}

const listPosts = (posts, searchValue, firstText) => {
  let html = /* html */ `
	<ul>
		<li>
			<a href="${window.location.origin}?s=${searchValue}">
				${firstText} <q><strong>${searchValue}</strong></q>
			</a>
		</li>
	`

  if (posts.length) {
    posts.forEach((post) => {
      html += /* html */ `
			<li>
				<a href="${post.url}">
					${post.title}
				</a>
			</li>
			`
    })
  }

  html += /* html */ '</ul>'

  return html
}

const noPostsFound = (notFoundText) => {
  return /* html */ `
		<ul>
			<li>
				<a>${notFoundText}</a>
			</li>
		</ul>
	`
}

export const searchPosts = () => {
  const wrappers = []

  const headerWrapper = document.querySelector('.search-offcanvas')
  if (headerWrapper) {
    wrappers.push(headerWrapper)
  }

  if (wrappers.length) {
    wrappers.forEach((wrapper) => {
      const searchForm = wrapper.querySelector('[data-js="search-form"]')
      const searchResultsWrapper = wrapper.querySelector('[data-js="search-results-wrapper"]')
      if (searchForm && searchResultsWrapper) {
        const searchInput = searchForm.querySelector('input[type="search"]')
        if (searchInput) {
          const queryParams = {
            nonce: variables.restNonce,
            per_page: 5
          }

          // Setup interval variables
          let typingTimer
          const doneTypingInterval = 250

          searchInput.addEventListener('input', () => {
            clearTimeout(typingTimer)
            typingTimer = setTimeout(() => {
              const value = searchInput.value
              if (value !== '' && value.length >= 3) {
                queryParams.search = value

                searchResultsWrapper.innerHTML = '<ul><li>' + searchResultsWrapper.dataset.loadingText + '</li></ul>'

                // Query posts with previously declared params
                fetch(`${variables.restURL}/wp/v2/search?${new URLSearchParams(queryParams)}`)
                  .then(async (response) => {
                    const posts = await response.json()
                    if (posts.length) {
                      // Append posts to html
                      const html = listPosts(posts, value, searchResultsWrapper.dataset.text)

                      searchResultsWrapper.innerHTML = ''

                      searchResultsWrapper.insertAdjacentHTML('afterbegin', html)
                    } else {
                      // Append no result found message to html
                      const html = noPostsFound(searchResultsWrapper.dataset.notfoundText)

                      searchResultsWrapper.innerHTML = ''

                      searchResultsWrapper.insertAdjacentHTML('afterbegin', html)
                    }
                  })
                  .catch((err) => {
                    console.error(`${err} - Ajax error search posts query`)
                  })
                  .finally(() => {
                    document.dispatchEvent(new Event('error-search-open'))
                  })
              } else {
                // Clear results area
                searchResultsWrapper.innerHTML = ''
              }
            }, doneTypingInterval)
          })
        }
      }
    })
  }
}
